import { GetPlanAlignmentFromDocumentation } from "./types";

export const getPlanAlignmentFromDocumentation: GetPlanAlignmentFromDocumentation =
  ({ documentationPlanAlignment }) => ({
    offsetX: documentationPlanAlignment?.offsetX ?? 0,
    offsetY: documentationPlanAlignment?.offsetY ?? 0,
    scale: documentationPlanAlignment?.scale ?? 1,
    rotation: documentationPlanAlignment?.rotation ?? 0,
  });
